import React, { forwardRef } from 'react';
import DSErrorBoundary from '../DSErrorBoundary';
const withLayout = (WrappedComponent) => {
    const layoutWrap = (props, ref) => (React.createElement(DSErrorBoundary, null,
        React.createElement(WrappedComponent, Object.assign({ ref: ref }, props))));
    const layoutWrapRFC = forwardRef(layoutWrap);
    layoutWrapRFC.displayName = `WithLayout(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;
    return layoutWrapRFC;
};
export default withLayout;
